import React from "react";
import { fmtNum } from "../../utils/format";

const STATUS_ITEMS = [
  { name: "Active",         key: "active_campaign",                token: "var(--pos-500)" },
  { name: "Initial review", key: "in_initial_approval_campaign",   token: "var(--warn-500)" },
  { name: "Admin review",   key: "in_for_review_campaign",         token: "var(--warn-700)" },
  { name: "Completed",      key: "completed_campaign",             token: "var(--info-500)" },
  { name: "Paused",         key: "paused_campaign",                token: "var(--n-500)" },
  { name: "Rejected",       key: "rejected_campaign",              token: "var(--neg-500)" },
  { name: "Draft",          key: "draft_campaign",                 token: "var(--n-400)" },
  { name: "Closed",         key: "closed_campaign",                token: "var(--n-600)" },
  { name: "Coming soon",    key: "coming_soon_campaign",           token: "var(--ink-500)" },
  { name: "Cancelled",      key: "cancelled_campaign",             token: "var(--neg-700)" },
];

const StatusPanel = ({ campaignStats }) => {
  const items = STATUS_ITEMS.map((s) => ({
    ...s,
    value: Number(campaignStats?.[s.key] || 0),
  })).filter((s) => s.value > 0);

  const total = items.reduce((sum, i) => sum + i.value, 0);

  return (
    <section className="card">
      <header className="card__head">
        <h2 className="card__title">Campaign status</h2>
        <span className="card__sub">N={fmtNum(total)}</span>
      </header>
      <div className="card__body">
        {total === 0 ? (
          <div style={{ color: "var(--tx-3)", fontSize: "var(--t-sm)" }}>No campaigns yet</div>
        ) : (
          <>
            <div className="dist-bar">
              {items.map((s) => (
                <span
                  key={s.name}
                  className="dist-bar__seg"
                  style={{ width: `${(s.value / total) * 100}%`, background: s.token }}
                  title={`${s.name}: ${s.value}`}
                />
              ))}
            </div>
            <div className="dist-list">
              {items.map((s) => {
                const pct = (s.value / total) * 100;
                return (
                  <div key={s.name} className="dist-row">
                    <span className="dist-dot" style={{ background: s.token }} />
                    <span className="dist-name">{s.name}</span>
                    <span className="dist-num">{fmtNum(s.value)}</span>
                    <span className="dist-pct">{pct.toFixed(1)}%</span>
                  </div>
                );
              })}
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default StatusPanel;
